import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDcpPeARB4z5_g5ErIu85-FDfDeOWHm65M",
  authDomain: "storyshot-b572e.firebaseapp.com",
  projectId: "storyshot-b572e",
  storageBucket: "storyshot-b572e.firebasestorage.app",
  messagingSenderId: "55289891028",
  appId: "1:55289891028:web:90b4b71680146622c2d341",
  measurementId: "G-GW1J6M4MPS"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Initialize Analytics (only in browser environment)
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null; 